import { render, staticRenderFns } from "./BasicUsersList.vue?vue&type=template&id=51f2f0b8&"
import script from "./BasicUsersList.vue?vue&type=script&lang=js&"
export * from "./BasicUsersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports